export const FAVORITES_LABELS = 'FavoritesLabels.FavoritesLabels_Sub';

export const addToBag = 'addToBag';
export const btnFavDeleteList = 'btn_fav_delete_list';
export const btnFavNo = 'btn_fav_no';
export const btnFavSend = 'btn_fav_send';
export const btnFavYesRemove = 'btn_fav_yes_remove';
export const lblAddFavoriteToYourList = 'lbl_add_favorite_to_your_list';
export const lblApply = 'lbl_apply';
export const lblClear = 'lbl_clear';
export const lblDontHaveFavorites = 'lbl_dont_have_favorites';
export const lblFavAll = 'lbl_fav_all';
export const lblFavAvailable = 'lbl_fav_available';
export const lblFavBrand = 'lbl_fav_brand';
export const lblFavClearance = 'lbl_fav_clearance';
export const lblFavCopyLink = 'lbl_fav_copyLink';
export const lblFavCopyLinkHeading = 'lbl_fav_copy_link_heading';
export const lblFavCopyLinkSuccess = 'lbl_fav_copy_link_success';
export const lblFavCreateNewList = 'lbl_fav_createNewList';
export const lblFavCreateNewListHeading = 'lbl_fav_create_new_list_heading';
export const lblFavDefaultList = 'lbl_fav_default_list';
export const lblFavEdit = 'lbl_fav_edit';
export const lblFavEditListSettings = 'lbl_fav_editListSettings';
export const lblFavEditList = 'lbl_fav_edit_list';
export const lblFavEmail = 'lbl_fav_email';
export const lblFavFacebook = 'lbl_fav_facebook';
export const lblFavFrom = 'lbl_fav_from';
export const lblFavFromEmailRequired = 'lbl_fav_from_email_required';
export const lblFavFromEmailValid = 'lbl_fav_from_email_valid';
export const lblFavGym = 'lbl_fav_gym';
export const lblFavListName = 'lbl_fav_list_name';
export const lblFavMessage = 'lbl_fav_message';
export const lblFavMessageRequired = 'lbl_fav_message_required';
export const lblFavMoveToAnotherList = 'lbl_fav_moveToAnotherList';
export const lblFavMyFavWishList = 'lbl_fav_myFavWishList';
export const lblFavMyFavorites = 'lbl_fav_myFavorites';
export const lblFavNewArrivals = 'lbl_fav_newArrivals';
export const lblFavOosMessage = 'lbl_fav_oos_message';
export const lblFavOosRemove = 'lbl_fav_oos_remove';
export const lblFavPjp = 'lbl_fav_pjp';
export const lblFavPriceHighLow = 'lbl_fav_priceHighLow';
export const lblFavPriceLowHigh = 'lbl_fav_priceLowHigh';
export const lblFavPurchased = 'lbl_fav_purchased';
export const lblFavRecentlyAdded = 'lbl_fav_recentlyAdded';
export const lblFavRemoveListMsg = 'lbl_fav_remove_list_msg';
export const lblFavSeeSuggestedException = 'lbl_fav_see_suggested_exception';
export const lblFavShare = 'lbl_fav_share';
export const lblFavShareListHeading = 'lbl_fav_share_list_heading';
export const lblFavShareListMsg = 'lbl_fav_share_list_msg';
export const lblFavSnj = 'lbl_fav_snj';
export const lblFavSoldOut = 'lbl_fav_soldOut';
export const lblFavSubject = 'lbl_fav_subject';
export const lblFavSubjectDefault = 'lbl_fav_subject_default';
export const lblFavSubjectRequired = 'lbl_fav_subject_required';
export const lblFavTo = 'lbl_fav_to';
export const lblFavToEmailMsg = 'lbl_fav_to_email_msg';
export const lblFilter = 'lbl_filter';
export const lblFilterBy = 'lbl_filter_by';
export const lblInspirationRequired = 'lbl_inspiration_required';
export const lblItemsToFavorite = 'lbl_items_to_favorite';
export const lblSort = 'lbl_sort';

export const FavoriteLabels = {
  FavoritesLabels: {
    FavoritesLabels_Sub: {
      [addToBag]: 'Add To Bag ',
      [btnFavDeleteList]: 'Delete List ',
      [btnFavNo]: 'No ',
      [btnFavSend]: 'SEND ',
      [btnFavYesRemove]: 'Yes, Remove ',
      [lblAddFavoriteToYourList]:
        'Browse by category or continue shopping to add to your list(s). You can save up to 5 lists. ',
      [lblApply]: 'APPLY',
      [lblClear]: 'CLEAR ',
      [lblDontHaveFavorites]: "Looks like you don't have any favorites yet! ",
      [lblFavAll]: 'All',
      [lblFavAvailable]: 'Available ',
      [lblFavBrand]: 'Brand: ',
      [lblFavClearance]: 'Clearance ',
      [lblFavCopyLink]: 'Copy Link\t',
      [lblFavCopyLinkHeading]: 'Copy this link and then send it to friends: ',
      [lblFavCopyLinkSuccess]: 'Copied to Clipboard ',
      [lblFavCreateNewList]: 'Create A New List ',
      [lblFavCreateNewListHeading]: 'Create a New Favorites List ',
      [lblFavDefaultList]: 'Make My Default List ',
      [lblFavEdit]: 'Edit ',
      [lblFavEditListSettings]: 'Edit List Settings ',
      [lblFavEditList]: 'Edit Favorites List ',
      [lblFavEmail]: 'Email ',
      [lblFavFacebook]: 'Facebook ',
      [lblFavFrom]: 'From ',
      [lblFavFromEmailRequired]: 'Please enter an email address ',
      [lblFavFromEmailValid]: 'Email format is invalid ',
      [lblFavGym]: 'Gymboree ',
      [lblFavListName]: 'List Name ',
      [lblFavMessage]: 'Message ',
      [lblFavMessageRequired]: 'Please enter a message for the email ',
      [lblFavMoveToAnotherList]: 'Move to another list ',
      [lblFavMyFavWishList]: 'Favorites Lists ',
      [lblFavMyFavorites]: 'FAVORITES ',
      [lblFavNewArrivals]: 'New Arrivals ',
      [lblFavOosMessage]: 'Oh no! Looks like one or more items on your list is sold out. ',
      [lblFavOosRemove]: 'Remove Now',
      [lblFavPjp]: 'PJ Place',
      [lblFavPriceHighLow]: 'Price: High To Low ',
      [lblFavPriceLowHigh]: 'Price: Low To High ',
      [lblFavPurchased]: 'Purchased ',
      [lblFavRecentlyAdded]: 'Recently Added ',
      [lblFavRemoveListMsg]: 'Are you sure you want to remove this list? ',
      [lblFavSeeSuggestedException]: 'Oops something went wrong, please retry. ',
      [lblFavShare]: 'Share ',
      [lblFavShareListHeading]: 'Share Your Favorites List ',
      [lblFavShareListMsg]: 'Make sure to specify a size and color for your items before sharing. ',
      [lblFavSnj]: 'Sugar&Jade',
      [lblFavSoldOut]: 'Sold Out ',
      [lblFavSubject]: 'Subject ',
      [lblFavSubjectDefault]: "Check Out My Favorites From The Children's Place! ",
      [lblFavSubjectRequired]: 'Please enter a subject line for the email ',
      [lblFavTo]: 'To ',
      [lblFavToEmailMsg]: 'Please enter one or more email addresses, separated by commas ',
      [lblFilter]: 'DISPLAY ',
      [lblFilterBy]: 'Display By: ',
      [lblInspirationRequired]: 'Need some inspiration? ',
      [lblItemsToFavorite]: 'Here are some great items to get your Favorites started. ',
      [lblSort]: 'SORT ',
    },
  },
};
